const config = {
  // apiUrl: 'http://localhost/SIMPRO%20BCK/simpro_bck_be/public/',
  // storageUrl: 'http://localhost/SIMPRO%20BCK/simpro_bck_be/storage/',

  apiUrl: "https://besimpro.bck.co.id/public/",
  storageUrl: "https://besimpro.bck.co.id/storage/",
};

export default config;
